// extracted by mini-css-extract-plugin
export default {"centerText":"reprompt-camera-and-microphone-permission-module__centerText--FonKQ","wrapper":"reprompt-camera-and-microphone-permission-module__wrapper--kgkvG"};